import { render, staticRenderFns } from "./ActiveUniRequest.vue?vue&type=template&id=208d7358&"
import script from "./ActiveUniRequest.vue?vue&type=script&lang=js&"
export * from "./ActiveUniRequest.vue?vue&type=script&lang=js&"
import style0 from "./ActiveUniRequest.vue?vue&type=style&index=0&id=208d7358&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports